import EventPage from "@src/components/event/EventPage";
import type { ComponentType, CSSProperties } from "react";
import React from "react";
import { useSearchParams } from "react-router-dom";

// 단순 배너 + 라우팅 버튼만 있는 이벤트
// img/imgMobile: URL 문자열 또는 정적 import한 이미지 모두 OK
type SimpleEvent = {
    imgMobile?: string;
    imgStyle?: CSSProperties;
    buttonText?: string;
    onClickHref?: string;
    showFaq?: boolean;
};

type CustomEvent = { component: ComponentType };

// 신규 이벤트는 이 객체에 추가 URL: /event?type=<key>
const EVENT_CONFIGS: Record<string, SimpleEvent | CustomEvent> = {
    architect: {
        // 건축사 광고
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/dce32963-85fc-4ed6-a032-b31231df248b.png",
        showFaq: false,
    },
    accompanying: {
        // 임장동행
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/f09210e3-261c-4755-9a63-173aa608bcb6.png",
        showFaq: false,
    },
    advertisement: {
        // 경매 지역/매물 광고
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/d0d7bfa4-3d71-4de0-be76-b0d647a6a49c.png",
        showFaq: false,
    },
    ownerCheckService: {
        // 소유자 확인 서비스
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/d9d8ece5-846f-4b45-8524-baf4af732516.jpeg",
        showFaq: false,
    },
    missgoAiDeep: {
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/587e95a4-3706-4848-a6a5-6fabf6c924fd.png",
        showFaq: false,
    },
    FiveFreeEvent: {
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/fe199a02-a27c-4b84-a4fc-03c2285b2413.png",
        showFaq: false,
    },
    missgoAiBannerEvent: {
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/964715ef-0e93-42cc-8a84-4d4995fbf7f6.png",
        showFaq: false,
    },
    AiChatBotBannerEvent: {
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/4ab4c731-00d1-47cc-b73f-2b00eaddcb7c.png",
        showFaq: false,
    },
    earlyBirdVip50: {
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/53dfce4f-3ebe-47dd-a921-d19bfa4833ce.png",
        showFaq: false,
    },
    aiDividendEvent: {
        imgMobile:
            "https://missgo-front-admin-files.s3.ap-northeast-2.amazonaws.com/news_thumbnails/93ca0b8b-3442-462e-9078-90bee5c94485.png",
        showFaq: false,
    },
};

const Page = () => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");
    const config = type ? EVENT_CONFIGS[type as keyof typeof EVENT_CONFIGS] : undefined;

    if (!config) return null;
    if ("component" in config) {
        const Component = config.component;
        return <Component />;
    }
    return <EventPage {...config} showButton={!!config.onClickHref} />;
};

export default Page;
